import {
    forEach,
    isObjectEmpty,
    join,
    MemberField,
    MemberFieldValueType,
    PresetMemberFieldKey,
    size
} from '@libs/shared';
import { tracker } from '~/utils';
import { ECode, TRACKER } from '~/constants';
import Intl from '@fx-ui/intl';

export const trackImport = (trackerFieldKeys: string[], members?: Record<string, any>[]) => {
    const fieldKeySet = new Set<string>();
    forEach(members, (member) => {
        const data = member ?? {};
        const pfData = member?.ext ?? {};
        forEach(trackerFieldKeys, (fieldKey) => {
            const fieldData = data[fieldKey] ?? pfData[fieldKey];
            if (!isObjectEmpty(fieldData)) {
                fieldKeySet.add(fieldKey);
            }
        });
        if (fieldKeySet.size === size(trackerFieldKeys)) {
            return false;
        }
    });
    if (fieldKeySet.size > 0) {
        tracker(TRACKER.MEMBER_INVITE_MULTI_DEFAULT_FIELD, join(Array.from(fieldKeySet), ','));
    }
};

/**
 * 获取成员导入错误文案
 * @param errData 错误信息
 */
export const getMemberInviteErrMsg = (errData?: { code?: number | string; message?: string }) => {
    const errorCode = errData?.code;
    switch (errorCode) {
        case ECode.MEMBER_NICKNAME_INVALID:
            return Intl.get('excel.import.error.P#6020', { length: 80 });
        case 1019:
            return Intl.get('excel.import.error.1019', { length: 80 });
        case ECode.USER_USERNAME_LENGTH_EXCEEDED:
        case ECode.MEMBER_USERNAME_TOO_LONG:
            return Intl.get('excel.import.error.P#1021', { length: 70 });
        case 1092:
            return Intl.get('excel.import.error.1092', { length: 70 });
        case ECode.MEMBER_FIELD_VALUE_TEXT_TOO_LONG:
        case ECode.MEMBER_FIELD_VALUE_DATE_FORMAT_INVALID:
            return errData?.message ?? Intl.get('excel.import.error.else');
        default:
            return Intl.get(
                `excel.import.error.${errorCode}`,
                undefined,
                errData?.message || Intl.get('excel.import.error.else')
            );
    }
};

/**
 * 获取成员预设字段列宽
 * @param field
 */
export const getMemberFieldColumnWidth = (field: MemberField) => {
    switch (field.key) {
        case PresetMemberFieldKey.Alias:
            return 114;
        case PresetMemberFieldKey.JobNumber:
            return 92;
        case PresetMemberFieldKey.Gender:
            return 68;
        default: {
            switch (field.valueType) {
                case MemberFieldValueType.Text:
                case MemberFieldValueType.Number:
                case MemberFieldValueType.Dept:
                case MemberFieldValueType.User:
                case MemberFieldValueType.Combo:
                    return 136;
                case MemberFieldValueType.Datetime:
                    return 114;
                case MemberFieldValueType.DeptGroup:
                case MemberFieldValueType.UserGroup:
                case MemberFieldValueType.ComboCheck:
                    return 186;
                default:
                    return 120;
            }
        }
    }
};
